// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppGroupRevenueLifetimeStatsResults = objectOf({
  lifetime_users: number,
  lifetime_users_by_app: recordOf({
    key: string,
    value: number,
  }),
  lifetime_revenue: number,
  lifetime_revenue_by_app: recordOf({
    key: string,
    value: number,
  }),
  // Optional: only returned when `shopify_markets_reporting` is enabled server-side.
  lifetime_revenue_by_country: maybe(
    recordOf({
      key: string,
      value: number,
    }),
    true
  ),
});
